import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ApizUIEditTab } from '@compiere-ws/models/apiz-domains';
import { isApizUIEditTab } from '@compiere-ws/models/apiz-domains.util';
import { CompiereDataGridRequestJSON } from '@compiere-ws/models/compiere-data-json';
import GridTabInfinityScrollUiComponent from '@iupics-components/standard/grid/grid-tab-infinity-scroll-ui/grid-tab-infinity-scroll-ui.component';
import { UICreatorService } from '@iupics-manager/managers/ui-creator/ui-creator.service';
import { IupicsEvent } from '@iupics-manager/models/iupics-event';
import { ColumnState } from '@iupics/apiz-grid';
import { AbstractWidgetComponent } from '../../abstract-widget.component';
import {map, switchMap} from "rxjs/operators";
import {filter, of} from "rxjs";

@Component({
  selector: 'iu-grid-widget',
  templateUrl: './grid-widget.component.html',
  styleUrls: ['./grid-widget.component.scss'],
  standalone: true,
  imports: [GridTabInfinityScrollUiComponent],
})
export default class GridWidgetComponent extends AbstractWidgetComponent implements OnInit {
  @ViewChild(GridTabInfinityScrollUiComponent) gridTabInfinityScroll: GridTabInfinityScrollUiComponent;

  data: any;
  gridTabFilter: any;
  tabId;
  isTabTopLevel;
  gridPaginator;
  container;
  DOMParentComponent;
  editView;
  initGridParams: { request?: CompiereDataGridRequestJSON; state?: ColumnState[] } = {};
  @Output() openTabEmitter: EventEmitter<any> = new EventEmitter();

  constructor(
    private uiCreatorService: UICreatorService,
    private cd: ChangeDetectorRef
  ) {
    super(uiCreatorService);
  }

  onRowSelectedOnGridTab(rowSelected) {
    if (!this.isPreview) {
      const dataUUID = rowSelected?.data[0]?.Data_UUID;
      if (dataUUID) {
        const record_id = dataUUID.split(',')[1];
        this.zoomAcross(record_id, this.data.tableName, null);
      }
    }
  }

  ngOnInit() {}

  updateWidget() {
    this.data = null;
    this.cd.detectChanges();
    this.initGridData();
  }

  flatten(children: any[]) {
    return children
      .map((child) => {
        if (child.children.length > 0) {
          return [...this.flatten(child.children)];
        } else return [child];
      })
      .flat();
  }

  onColumnStateChanged(columnState: ColumnState[]) {
    this.widget.gridState = JSON.stringify(columnState);
    this.widgetChanged.emit(this.widget);
  }

    initGridData() {
        if (!this.widget?.windowId || !this.widget?.tabId) return;

        const { windowId, tabId } = this.widget;

        const gridData$ = this.uiCreatorService.getWindow(windowId).pipe(
            // get editTabs from window
            map((editTabUI) => [...editTabUI.editTabs]),
            // check if tab exists there
            switchMap((children) => {
                const tab = children.find(
                    (child) => isApizUIEditTab(child) && child.tabId === tabId
                );

                if (tab) return of(tab);

                return this.uiCreatorService.getAllTabs(windowId).pipe(
                    map((allTabs) =>
                        allTabs.find(
                            (child) => isApizUIEditTab(child) && child.tabId === tabId
                        )
                    )
                );
            }),
            filter((tab): tab is ApizUIEditTab => !!tab) // filter out undefined
        );

        const sub = gridData$.subscribe((gridData) => {
            this.setGridData(gridData);
        });

        this.subscriptions.push(sub);
    }

    private setGridData(gridData: ApizUIEditTab) {
        this.tabId = gridData.tabId;
        this.gridPaginator = gridData.data.gridPaginator;
        this.gridTabFilter = gridData.data.gridTabFilter;
        this.isTabTopLevel = gridData.data.tabLevel === 0;
        this.container = this;

        if (this.widget?.gridRequest) {
            this.initGridParams.request = JSON.parse(this.widget.gridRequest);
        }

        if (this.widget?.gridState) {
            this.initGridParams.state = JSON.parse(this.widget.gridState);
        }

        this.data = gridData.data;
    }


    onChildUpdate(event: IupicsEvent): void {}

  onSiblingUpdate(event: IupicsEvent) {}

  onRemoveComponent(event: IupicsEvent) {}
}
